import { Injectable } from '@angular/core';
import moment from 'moment';
import { DailyFootfallPrediction } from '../../classes/models/prediction/DailyFootfallPrediction';

/**
 * This service sorts daily footfall predictions.
 */
@Injectable({
  providedIn: 'root'
})
export class DailyPredictionSortService {

  /**
   * Sorts daily footfall predictions by date in ascending order.
   * @param dailyPredictions daily footfall predictions to be sorted.
   */
  sortByDate(dailyPredictions: DailyFootfallPrediction[]): DailyFootfallPrediction[] {
    return dailyPredictions.sort(
      (a, b) =>
        moment(a.date, 'YYYY-MM-DD')
          .isBefore(moment(b.date, 'YYYY-MM-DD')) ? -1 : 1
    );
  }
}
